import React, { Component,useState } from "react";
import store from "@/redux/store";
import { useNavigate } from "react-router-dom";


import { Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/20/solid'
import {NotificationItem} from "@/views/messages/NotificationItem";
import {Export} from "@/views/messages/Export";

 
export function MessageNotificationView({...props}) {
    let singleMessage = false;
    const {key} = props.Notification;

    
    if(props.Notification && props.Notification.message) {
        singleMessage = JSON.parse(props.Notification.message);
    }

    
  return (
    <>
        <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-start px-4 py-6 sm:items-start sm:p-6"
      >
 <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
    {singleMessage &&
    <Export key={"Single"+key} id="M1"  item={singleMessage} />
    }
        {props.messages && Array.isArray(props.messages) && props.messages.length > 0 && props.messages.map((item, index) => (
            <NotificationItem key={"M"+index} id="M1"  item={item} lastItem={(Array.isArray(props.messages) && props.messages.length-1 == index) ? true : false}/>
        ))}
        </div>
        </div>
    </>
      );
}      